import type { ThemeConfig } from 'antd';

/** 支付服务商公开品牌色；与后台主题色分开维护，避免品牌标志随主题漂移。 */
export const paymentBrandColors = {
  apple: '#111111',
  stripe: '#635bff',
  googlePlayCyan: '#00d6ff',
  googlePlayGreen: '#00f076',
  googlePlayYellow: '#ffdc00',
  googlePlayRed: '#ff3a44',
  wechat: '#07c160',
} as const;

/**
 * 全局 Ant Design 主题 token。
 * 克制的深靛主色 + 中性灰 + 4px 圆角，目标是"简洁大气"而非默认商用蓝。
 */
export const theme: ThemeConfig = {
  token: {
    colorPrimary: '#1e40af',
    colorInfo: '#1e40af',
    colorSuccess: '#10b981',
    colorWarning: '#f59e0b',
    colorError: '#ef4444',
    colorBgLayout: '#f7f8fa',
    colorBorder: '#e5e7eb',
    colorBorderSecondary: '#f0f1f3',
    colorTextHeading: '#111827',
    colorText: '#1f2937',
    colorTextSecondary: '#4b5563',
    colorTextTertiary: '#6b7280',
    borderRadius: 4,
    borderRadiusLG: 6,
    borderRadiusSM: 2,
    fontSize: 14,
    fontFamily:
      '"Inter", "HarmonyOS Sans", "PingFang SC", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", sans-serif',
    wireframe: false,
  },
  components: {
    Layout: {
      headerBg: '#ffffff',
      siderBg: '#0f172a',
      triggerBg: '#0b1120',
      bodyBg: '#f7f8fa',
    },
    Menu: {
      darkItemBg: '#0f172a',
      darkSubMenuItemBg: '#0b1120',
      darkItemSelectedBg: '#1e293b',
      darkItemHoverBg: '#1e293b',
    },
    Table: {
      headerBg: '#fafbfc',
      headerColor: '#374151',
      rowHoverBg: '#f9fafb',
      borderColor: '#f0f1f3',
      cellPaddingBlock: 12,
    },
    Card: {
      borderRadiusLG: 8,
    },
    Button: {
      controlHeight: 34,
      fontWeight: 500,
    },
  },
};
